import classes from "./ActivityEditor.module.css";
import DropdownQuestionType from "../../components/DropdownQuestionType";
import CreateQuestionVideoGuidance from "../../questions/CreateQuestionVideoGuidance";
import DropdownTimeLimit from "../../components/DropdownTimeLimit";
import DropdownWeightage from "../../components/DropdownWeightage";
import React, {useEffect, useState} from "react";
import {
    DELETE_BTN,
    DUPLICATE_BTN, GRADE_SCHEMA,
    QUESTION_TYPES, SAVE_TO_QUESTION_BANK_TEXT,
    VIDEO_ERROR_CI
} from "../../utils/constants";
import {notifyError} from "../../utils/helpers";
import {updateQuestionType, updateTimeLimit, updateWeightage} from "../../utils/questionUpdate";
import {YuJaKebabMenu} from "../../components/standardization/YuJaKebabMenu";
import {deleteQuestion} from "../../utils/questionUtils";
import {PollApiCalls} from "../../apis/PollApiCalls";
import {useImageLoaderManager} from "../../hooks/useImageLoaderManager";
import SaveQuestionBankModal from "../../components/modals/SaveQuestionBankModal";

export default function ActivityEditorQuestionManagerBar ({
                                                              draftActivity,
                                                              setDraftActivity,
                                                              currQueDisplay,
                                                              setCurrQueDisplay,
                                                              shownQuestionType,
                                                              setShownQuestionType,
                                                              userSettings,
                                                              questionBankId,
                                                              hasReleased
})  {
    const {pollKey, questions=[], gradeSchema} = draftActivity;
    const { duplicateImagesOfQuestion, duplicateImagesOfQuestionBank} = PollApiCalls();
    const [questionBankModal, setQuestionBankModal] = useState(false);


    const rowStyle = {
        display: "flex",
        alignItems: "center",
        gap: 10
    }

    const setQuestions = (questions) => {
        const copy = JSON.parse(JSON.stringify(draftActivity));
        copy.questions = questions;
        setDraftActivity(copy);
    }

    const {
        setQuestionLoading,
        resetImages,
        setImages
    } = useImageLoaderManager(questions, setQuestions);


    useEffect(() => {
        setShownQuestionType(questions[currQueDisplay - 1].questionType);
    }, [questions, currQueDisplay]);

    const handleQuestionTypeUpdate = (qType) => {
        const copy = JSON.parse(JSON.stringify(draftActivity));
        const selectedQuestion = copy.questions.find(q => q.serialNo === currQueDisplay);
        const {directLinkEvp, questionType} = selectedQuestion;

        if(qType === QUESTION_TYPES.CI.description && directLinkEvp) {
            notifyError(VIDEO_ERROR_CI);
        } else {
            copy.questions = updateQuestionType(qType, currQueDisplay - 1, questions, questionType, userSettings);
            if (gradeSchema === GRADE_SCHEMA.UNGRADED.key) {
                copy.questions.find(q => q.serialNo === currQueDisplay).weightage = 0;
            }
            setDraftActivity(copy);
        }
    };


    const handleTimeLimitUpdate = (v) => {
        if (!v) {
            v = 0;
        } else {
            v = parseInt(v);
        }
        const copy = JSON.parse(JSON.stringify(draftActivity));
        copy.questions = updateTimeLimit(v, currQueDisplay - 1, copy.questions);
        setDraftActivity(copy);
    };

    const handleWeightageUpdate = (v) => {
        if (!v) {
            v = 0;
        } else {
            v = parseInt(v);
        }
        const copy = JSON.parse(JSON.stringify(draftActivity));
        copy.questions = updateWeightage(v, currQueDisplay - 1, copy.questions);

        // if (!v) {
        //     let que = copy.questions.find(q => q.serialNo === currQueDisplay);
        //     que.correctAnswers = resetCorrectAnswer(que.questionType);
        // }
        setDraftActivity(copy);
    };

    const clickDuplicate = async () => {
        const selectedQuestion = questions[currQueDisplay - 1];
        const {serialNo} = selectedQuestion;


        const questionsCopy = JSON.parse(JSON.stringify(questions));
        let duplicatedQuestion = JSON.parse(JSON.stringify(selectedQuestion));
        let newQuestions = [];
        for (const q of questionsCopy) {
            if (q.serialNo === serialNo) {
                newQuestions.push({...q, checked: false});
                duplicatedQuestion.serialNo = q.serialNo + 1;
                duplicatedQuestion.checked = true;
                newQuestions.push(duplicatedQuestion);
            } else if (q.serialNo > serialNo) {
                newQuestions.push({ ...q, serialNo: q.serialNo + 1, checked: false });
            } else {
                newQuestions.push({ ...q, checked: false });
            }
        }


        const resourceMapping = setQuestionLoading(duplicatedQuestion);
        setQuestions(newQuestions);
        setCurrQueDisplay(serialNo + 1);

        if (!resourceMapping || !Object.entries(resourceMapping).length) {
            return;
        }

        //duplicate images of the question
        if (!questionBankId) {
        duplicateImagesOfQuestion(pollKey, selectedQuestion, resourceMapping).then((returnedMapping) => {
            //error
            if (!returnedMapping) {
                resetImages(Object.values(resourceMapping));
                return;
            }

            //set imageURL
            setImages(returnedMapping);
        });
        } else {
            duplicateImagesOfQuestionBank(questionBankId, resourceMapping).then((returnedMapping) => {
                //error
                if (!returnedMapping) {
                    resetImages(Object.values(resourceMapping));
                    return;
                }

                //set imageURL
                setImages(returnedMapping);
            });
        }
    };

    const clickDelete = () => {
        const selectedQuestion = questions[currQueDisplay - 1];
        const {serialNo} = selectedQuestion;
        const newQuestions = deleteQuestion(selectedQuestion, questions);
        setCurrQueDisplay(serialNo === 1 ? 1 : serialNo - 1);
        setQuestions(newQuestions.length === 0 ? [{serialNo: 1}] : newQuestions);
    };


    return (
        <>
            <SaveQuestionBankModal
                selectedQuestion={questions[currQueDisplay - 1]}
                show={questionBankModal}
                setModalShow={setQuestionBankModal}
                pollKey={pollKey}
            />
            <div className={classes.questionManageContainer}>
                <div style={{...rowStyle, flex: 1, minWidth: 0, flexWrap: "wrap", gap: 10}}>
                    <div style={rowStyle}>
                        <DropdownQuestionType
                            questionType={questions[currQueDisplay - 1].questionType}
                            setShownQuestionType={setShownQuestionType}
                            handleQuestionTypeUpdate={handleQuestionTypeUpdate}
                        />
                        <CreateQuestionVideoGuidance questionType={shownQuestionType}/>
                    </div>
                    <span style={{flex: 1, minWidth: 0}}/>
                    <div style={{...rowStyle,}}>
                        <DropdownTimeLimit
                            timeLimit={questions[currQueDisplay - 1].hasOwnProperty("timeLimit") ? questions[currQueDisplay - 1].timeLimit : 0}
                            setTimeLimit={handleTimeLimitUpdate}
                        />
                        {gradeSchema === GRADE_SCHEMA.GRADED.key &&
                            <DropdownWeightage
                                weightage={questions[currQueDisplay - 1].hasOwnProperty("weightage") ? questions[currQueDisplay - 1].weightage : 0}
                                setWeightage={handleWeightageUpdate}
                            />
                        }
                    </div>
                </div>


                <YuJaKebabMenu style={{padding: 0}}>
                    <YuJaKebabMenu.Menu>
                        {!questionBankId &&
                            <YuJaKebabMenu.Item onClick={() => setQuestionBankModal(true)}>
                                {SAVE_TO_QUESTION_BANK_TEXT}
                            </YuJaKebabMenu.Item>
                        }

                        {!hasReleased &&
                            <YuJaKebabMenu.Item onClick={clickDuplicate}>
                                {DUPLICATE_BTN}
                            </YuJaKebabMenu.Item>
                        }

                        {!hasReleased &&
                            <YuJaKebabMenu.Item onClick={clickDelete}>
                                {DELETE_BTN}
                            </YuJaKebabMenu.Item>
                        }

                    </YuJaKebabMenu.Menu>
                </YuJaKebabMenu>

            </div>
        </>
    );
}